import {Component, OnDestroy, OnInit} from "@angular/core";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {Store} from "@ngxs/store";
import {PreguntaModelDTO} from "@Models";
import {TipoPreguntaBreakpointComponent} from "../tipo-pregunta-breakpoint/tipo-pregunta-breakpoint.component";


@Component({
    selector: "app-tipo-pregunta-multiple",
    templateUrl: "./tipo-pregunta-multiple.component.html",
    styleUrls: ["./tipo-pregunta-multiple.component.scss"]
})
export class TipoPreguntaMultipleComponent extends TipoPreguntaBreakpointComponent implements OnInit, OnDestroy {
    public pregunta: PreguntaModelDTO;

    constructor(private tiposPreguntasService: TiposPreguntasService, store: Store) {
        super(store);
    }

    public ngOnInit(): void {
        this.pregunta = this.tiposPreguntasService.preguntaModel;
    }
}
